import * as React from 'react';

import {DistributionBar} from 'shells/card/distribution-bar/distribution-bar';
import {colors} from 'shells/colors/colors';
import {ThumbnailButtonCard} from 'shells/thumbnail/thumbnail-button-card/thumbnail-button-card';
import {useResizeObserver} from 'shells/utils/hooks/use-resize-observer';

import type {EditionFragment as Edition} from 'nutshell-graphql-types';

import {REMAINDER} from '../a-b-testing/edition-content/a-b-test-details';
import {getComparisonDetails} from '../a-b-testing/helpers';

type Props = {
    edition: Edition;
};

export function NewPreviewBody(props: Props) {
    const comparisonEditionTemplate =
        props.edition.comparisonEdition && props.edition.comparisonEdition.emailTemplate;
    const {comparisonSubject, comparisonPreviewText, comparisonThumbnailUrl} = getComparisonDetails(
        props.edition,
        comparisonEditionTemplate
    );

    const sections = [
        {
            type: 'defined',
            color: colors.plum,
            percent: (props.edition.comparison && props.edition.comparison.sendPercentage / 2) || 0,
            label: 'A',
            labelColor: colors.white,
        },
        {
            type: 'defined',
            color: colors.sidebarPrimary,
            percent: (props.edition.comparison && props.edition.comparison.sendPercentage / 2) || 0,
            label: 'B',
            labelColor: colors.white,
        },
    ];

    const containerRef = React.useRef(null);
    const [thumbnailHeight, setThumbnailHeight] = React.useState(0);
    const [, height] = useResizeObserver(containerRef.current);

    React.useEffect(() => {
        if (containerRef.current) {
            // @ts-expect-error
            setThumbnailHeight(containerRef.current.clientHeight);
        }
        if (typeof height === 'number') {
            setThumbnailHeight(height);
        }
    }, [height]);

    return (
        <>
            <div style={{height: '42%'}} ref={containerRef}>
                <ThumbnailButtonCard
                    title={props.edition.emailTemplate ? props.edition.emailTemplate.subject : ''}
                    secondaryInfo={
                        props.edition.emailTemplate && props.edition.emailTemplate.previewText
                    }
                    tertiaryInfo={props.edition.isABTesting ? 'Version A' : undefined}
                    thumbnail={
                        props.edition.emailTemplate && props.edition.emailTemplate.thumbnailUrl
                    }
                    thumbnailHeight={thumbnailHeight * 0.7}
                    onClick={() => {}}
                    isDisabled={true}
                    backgroundColor={props.edition.backgroundColor}
                />
            </div>
            {props.edition.isABTesting ? (
                <div style={{height: '42%'}}>
                    <ThumbnailButtonCard
                        title={comparisonSubject || ''}
                        secondaryInfo={comparisonPreviewText}
                        tertiaryInfo='Version B'
                        thumbnail={comparisonThumbnailUrl}
                        thumbnailHeight={thumbnailHeight * 0.7}
                        onClick={() => {}}
                        isDisabled={true}
                        backgroundColor={props.edition.backgroundColor}
                    />
                </div>
            ) : undefined}
            {props.edition.isABTesting ? (
                <div style={{alignSelf: 'stretch'}} className='flex'>
                    {/* @ts-expect-error */}
                    <DistributionBar sections={sections} remainder={REMAINDER} />
                </div>
            ) : undefined}
        </>
    );
}
